import InlineSvg from 'approot/shared/inline-svg/inline-svg';
import * as Styled from './interactive-response-audio-static.style';

const InteractiveResponseAudioStatic = () => {
  return (
    <Styled.InteractiveResponseAudioStatic>
      <InlineSvg id="audio" width={20} height={20} />
    </Styled.InteractiveResponseAudioStatic>
  );
};

export default InteractiveResponseAudioStatic;
